<div class="input">
	<div class="advanced" 
		*ngIf="advancedMode"
	>
		<input
			type="text" name="scheduler-cron"
			[(ngModel)]="modelValue"
			(ngModelChange)="onCronStringChange()"
			[placeholder]="'0 * * * *'"
		/>
	</div>
	<div class="simple-mode" *ngIf="!advancedMode">
		<div class="cols">
			<div>
				Only on specific hours: (<span (click)="toggleHours()">Show {{ !showAllHours ? 'all' : 'less' }}</span>) <br />
				<bb-checkbox-list
					[options]="hourOptions"
					[(ngModel)]="hours"
					name="hours"
					(ngModelChange)="updateCronString()"
				></bb-checkbox-list>
			</div>
			<div>
				On minute: 
				<input
					type="text" name="minute" max="59"
					[(ngModel)]="minuteString"
					(ngModelChange)="updateCronString()"
				/>
			</div>
			<div>
				Only on specific days: <br />
				<bb-checkbox-list
					[options]="weekdayOptions"
					[(ngModel)]="weekDays"
					name="weekDays"
					(ngModelChange)="updateCronString()"
				></bb-checkbox-list>
			</div>
		</div>
		<div class="cron-string">
			Cron value: <span class="cron-value">{{ modelValue }}</span>
		</div>
	</div>
	<span (click)="onToggleModeClick()" class="toggle-mode-button button">
		{{ (advancedMode ? 'OPEN_HELPER' : 'CLOSE_HELPER') | translate }}
	</span>
	<a [href]="helpLink" target="_blank">Help on CRON <i class="fa fa-external-link"></i></a>
</div>
